import { animate, style, transition, trigger } from "@angular/animations";
import { ChangeDetectionStrategy, Component, HostBinding, OnInit, computed, input, output, signal } from "@angular/core";
import { isRunningInIE } from "@globals/helper-functions";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "bi-notification-bar",
  imports: [ButtonModule],
  templateUrl: "./bi-notification-bar.component.html",
  styleUrls: ["./bi-notification-bar.component.scss"],
  animations: [
    trigger("foldInOut", [
      transition(":enter", [style({ opacity: "0", transform: "translateY(-80%)" }), animate("{{speed}}ms cubic-bezier(.44,1,.78,1.47)", style({ opacity: "1", transform: "translateY(0)" }))], {
        params: { speed: 400 }
      }),
      transition(":leave", [style({ opacity: "1", transform: "translateY(0)" }), animate("{{speed}}ms cubic-bezier(.44,1,.78,1.47)", style({ opacity: "0", transform: "translateY(-80%)" }))], {
        params: { speed: 400 }
      })
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class]": "classList()",
    "[style]": "style()"
  }
})
export class BiNotificationBarComponent implements OnInit {
  readonly title = input.required<string>();
  readonly text = input<string>();
  /**
   * The font color for the title and the text.
   */
  readonly cssFontColor = input<string>();
  readonly backgroundColor = input<"yellow" | "red" | "green" | "blue">("yellow");
  readonly cssBackgroundColor = input<string>();
  /**
   * The font that the title and text will use.
   */
  readonly font = input<string>();

  /**
   * Width of the notification bar. "large" = 100%, "medium" = 75% and "small" = 50%
   */
  readonly widthSize = input<"large" | "medium" | "small">("large");

  /**
   * If true, an "X" will be displayed
   */
  readonly dismissable = input(true);
  /**
   * Whether to show a button or not. Will be displayed as a "link-button", e.i. no background and borders...
   */
  readonly hasButton = input(false);
  readonly buttonText = input<string>();

  /**
   * ONLY relevant if "hasButton" is true. Controls whether the button should be displayed on a new line or not. Default false (e.i. inline with the text).
   */
  readonly buttonOnNewLine = input(false);
  public readonly newLineButtonClass = computed(() => (this.buttonOnNewLine() ? "block my-0 mx-auto" : ""));

  public readonly classList = signal("");

  public readonly style = signal("");

  public readonly isBadBrowser = signal(!isRunningInIE());

  buttonClick = output();
  onDismiss = output();

  public readonly titleAndTextStyles = signal("");

  @HostBinding("@foldInOut") public foldInHost = true;

  public ngOnInit() {
    // Set host classes depending on inpups
    if (this.backgroundColor()) this.classList.update(currentVal => currentVal + this.backgroundColor());
    if (this.cssBackgroundColor()) this.style.update(style => style + " background: " + this.cssBackgroundColor() + " !important;");
    if (this.font()) this.titleAndTextStyles.update(currentVal => currentVal + " font-family: " + this.font() + "; ");
    if (this.cssFontColor()) this.titleAndTextStyles.update(currentVal => currentVal + " color: " + this.cssFontColor() + "; ");
    if (this.widthSize()) this.classList.update(currentVal => (currentVal += " " + this.widthSize()));
  }
}
